import type {
  PermissionAccessControlType,
  PermissionEntityType,
  PermissionResourceType,
  UserPermissionType,
} from './types';

type UserPermissionKeyType =
  `${PermissionResourceType}${PermissionEntityType}${PermissionAccessControlType}`;

export const UserPermissions: Partial<
  Record<UserPermissionKeyType, UserPermissionType>
> = {
  /** Організації */
  OrganizationsOrganizationRead: 'organizations.organization.read',
  OrganizationsOrganizationManage: 'organizations.organization.manage',
  /** Співробітники */
  OrganizationsEmployeeRead: 'organizations.employee.read',
  OrganizationsEmployeeManage: 'organizations.employee.manage',

  /** Контрагенти */
  OrganizationsCounterpartiesRead: 'organizations.counterparties.read',
  OrganizationsCounterpartiesWrite: 'organizations.counterparties.write',

  /** Договори */
  OrganizationsContractsRead: 'organizations.contracts.read',
  OrganizationsContractsWrite: 'organizations.contracts.write',

  /** Об'єкти споживання */
  OrganizationsConsumptionObjectsRead: 'organizations.consumptionobjects.read',
  OrganizationsConsumptionObjectsWrite:
    'organizations.consumptionobjects.write',

  /** ПОН */
  OrganizationsLastResortSupplierRead: 'organizations.lastresortsupplier.read',
  OrganizationsLastResortSupplierWrite:
    'organizations.lastresortsupplier.write',

  /** Портфель постачальника */
  OrganizationsSupplierPortfolioRead: 'organizations.supplierportfolio.read',
  OrganizationsSupplierPortfolioWrite: 'organizations.supplierportfolio.write',
  OrganizationsSupplierPortfolioDiscrepanciesWrite:
    'organizations.supplierportfoliodiscrepancies.write',

  /** Ролі та дозволи */
  OrganizationsRoleAndPermissionRead: 'organizations.roleandpermission.read',
  OrganizationsRoleAndPermissionWrite: 'organizations.roleandpermission.manage',

  /** Банківські дані */
  OrganizationsBankAccountsRead: 'organizations.bankaccounts.read',
  OrganizationsBankAccountsManage: 'organizations.bankaccounts.manage',

  /** Облік споживання: прогнозування */
  ConsumptionAccountingForecastingRead:
    'consumptionaccounting.forecasting.read',
  ConsumptionAccountingForecastingWrite:
    'consumptionaccounting.forecasting.write',

  /** Облік споживання: номінація */
  ConsumptionAccountingNominationRead: 'consumptionaccounting.nomination.read',
  ConsumptionAccountingNominationWrite:
    'consumptionaccounting.nomination.write',

  /** Облік споживання: попередній розподіл */
  ConsumptionAccountingPreliminaryAllocationRead:
    'consumptionaccounting.preliminaryallocation.read',
  ConsumptionAccountingPreliminaryAllocationWrite:
    'consumptionaccounting.preliminaryallocation.write',

  /** Облік споживання: остаточний розподіл */
  ConsumptionAccountingFinalAllocationRead:
    'consumptionaccounting.finalallocation.read',
  ConsumptionAccountingFinalAllocationWrite:
    'consumptionaccounting.finalallocation.write',

  /** Облік споживання: закриття місяця */
  ConsumptionAccountingMonthCloseManage:
    'consumptionaccounting.monthclose.manage',

  /** Баланс газу: балансуюча група */
  GasBalanceBalancingGroupRead: 'gasbalance.balancinggroup.read',
  GasBalanceBalancingGroupWrite: 'gasbalance.balancinggroup.write',

  /** Баланс газу: фінансове забезпечення */
  GasBalanceFinancialSecurityRead: 'gasbalance.financialsecurity.read',
  GasBalanceFinancialSecurityWrite: 'gasbalance.financialsecurity.write',

  /** Баланс газу: баланс */
  GasBalanceBalanceRead: 'gasbalance.balance.read',
  GasBalanceBalanceWrite: 'gasbalance.balance.write',

  /** Баланс газу: небаланс */
  GasBalanceImbalanceRead: 'gasbalance.imbalance.read',
  GasBalanceImbalanceWrite: 'gasbalance.imbalance.write',

  /** Баланс газу: ресурс */
  GasBalanceResourceRead: 'gasbalance.resource.read',
  GasBalanceResourceWrite: 'gasbalance.resource.write',

  /** Баланс газу: перерозподіл ресурсу на добу (PO, 2026-09-28) */
  GasBalanceResourceRedistributionWrite:
    'gasbalance.resourceredistribution.write',

  /** Звіти і аналітика: звіти */
  ReportsAndAnalyticsReportRead: 'reportsandanalytics.report.read',
  ReportsAndAnalyticsReportWrite: 'reportsandanalytics.report.write',
  ReportsAndAnalyticsBiDashboardsRead: 'reportsandanalytics.bidashboards.read',

  /** Налаштування: рахунки */
  SettingsInvoiceSettingsRead: 'settings.invoicesettings.read',
  SettingsInvoiceSettingsWrite: 'settings.invoicesettings.write',

  /** Налаштування: фізико-хімічні показники газу */
  SettingsPhysicoChemicalIndicatorsRead:
    'settings.physicochemicalindicators.read',
  SettingsPhysicoChemicalIndicatorsWrite:
    'settings.physicochemicalindicators.write',
};
